// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentRewardRepresentation } from './StudentRewardRepresentation'
import {
  StudentRewardRepresentationFromJSON,
  StudentRewardRepresentationFromJSONTyped,
  StudentRewardRepresentationToJSON,
} from './StudentRewardRepresentation'

/**
 *
 * @export
 * @interface StudentRewardsRepresentation
 */
export interface StudentRewardsRepresentation {
  /**
   *
   * @type {Array<StudentRewardRepresentation>}
   * @memberof StudentRewardsRepresentation
   */
  rewards: Array<StudentRewardRepresentation>
}

/**
 * Check if a given object implements the StudentRewardsRepresentation interface.
 */
export function instanceOfStudentRewardsRepresentation(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'rewards' in value

  return isInstance
}

export function StudentRewardsRepresentationFromJSON(
  json: any,
): StudentRewardsRepresentation {
  return StudentRewardsRepresentationFromJSONTyped(json, false)
}

export function StudentRewardsRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentRewardsRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    rewards: (json['rewards'] as Array<any>).map(
      StudentRewardRepresentationFromJSON,
    ),
  }
}

export function StudentRewardsRepresentationToJSON(
  value?: StudentRewardsRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    rewards: (value.rewards as Array<any>).map(
      StudentRewardRepresentationToJSON,
    ),
  }
}
